import { Edit24, DataView24, Checkmark } from "@carbon/icons-react";
import React, { useState, useEffect } from "react";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import PaginatedDataTable from "../../components/Table/PaginatedDataTable";
import DataOperationButton from "../../components/Buttons/DataOperationButton";
import AddEntityButton from "../../components/Buttons/AddEntityButton";
import { buildSearchQuery, setPaging } from "../../services/Utils";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Task24 } from "@carbon/icons-react";
import { ListChecked24 } from "@carbon/icons-react";
import { Checkmark24 } from "@carbon/icons-react";
import { Subtract24 } from "@carbon/icons-react";

const tableHeaders = [
  {
    header: "Título",
    key: "vacancyTitle",
  },
  {
    header: "Empresa",
    key: "companyName",
  },
  {
    header: "Província",
    key: "provinceName",
  },
  {
    header: "Distrito",
    key: "districtName",
  },
  {
    header: "Genero",
    key: "traineeGender",
  },
  {
    header: "Elegível",
    key: "isEligible",
  },
  {
    header: "Pontuada",
    key: "scored",
  },
  {
    header: "Visualizar",
    key: "id",
  },
];

const ListInternshipApplicationsPage = () => {
  const [showSpinner, setShowSpinner] = useState(true);
  const [query, setQuery] = useState("");
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalElements, setTotalElements] = useState(0);
  const { user, isWinner } = useContext(AuthContext);
  const [uri, setUri] = useState(
    isWinner
      ? `/internships/companies/NUR${user.username}/applications`
      : `/internships/applications`
  );
  const navigate = useNavigate();

  const getData = async (url) => {
    try {
      const response = await http.get(uri);
      setItems(response.data);
      setShowSpinner(false);
    } catch (error) {}
  };

  const getCellContent = (cell, id) => {
    if (cell.info.header === "isEligible") {
      if (cell.value == null) {
        return "NA";
      }
      return cell.value == true ? "Sim" : "Não";
    }
    if (cell.info.header === "scored") {
      return (
        <DataOperationButton
          operations={[
            {
              id: id,
              url: "",
              icon: cell.value == true ? Checkmark24 : Subtract24,
              title: "Pontuado",
            },
          ]}
        />
      );
    }
    if (cell.info.header === "id") {
      return (
        <DataOperationButton
          operations={[
            {
              id: id,
              url: `../candidaturas-para-estagio/${cell.value}`,
              icon: DataView24,
              title: "Consultar",
            },
          ]}
        />
      );
    }

    return cell.value;
  };

  const onSearch = async (data) => {
    try {
      const q = buildSearchQuery(data);
      setQuery(q);
      getData(`${uri}${q}`);
    } catch (error) {}
  };

  const onPageChange = async (pageInfo) => {
    try {
      getData(`${uri}${query}${setPaging(pageInfo)}`);
    } catch (error) {}
  };

  useEffect(() => {
    if (!isWinner) {
      setUri(`/internships/applications`);
    }
    getData();
  }, []);

  return (
    <Card title="Candidaturas para Estágio" showSpinner={showSpinner}>
      <PaginatedDataTable
        headers={tableHeaders}
        items={items}
        onPageChange={onPageChange}
        onSearch={onSearch}
        page={page}
        pageSize={pageSize}
        totalElements={totalElements}
        getCellContent={getCellContent}
        paginate={false}
      ></PaginatedDataTable>
    </Card>
  );
};

export default ListInternshipApplicationsPage;
